import Swiper, { Navigation, Pagination } from 'swiper';
import Autolinker from 'autolinker';
Swiper.use([Navigation, Pagination]);

/**
 * Init Sticky Sidebar
 */
var stickySidebar;
function initStickySidebar() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    var currentPosition = $('.stopsticky').position().top - $(window).height();
    var k = $(".stopsticky").outerHeight();
  } else if ($('.sticky').length){
    stickySidebar = new StickySidebar('.sticky', {
      topSpacing: 20,
      bottomSpacing: 0,
      resizeSensor: true,
      containerSelector: '.hange-details-wrapper'
    });
  }
}



jQuery(function () {
  initStickySidebar();

  tippedCreate('.tip-message-1', 'textarea-tip-1', { position: 'top', maxWidth: 330 });
  tippedCreate('.tip-message-2', 'textarea-tip-2', { position: 'top', maxWidth: 330 });
  tippedCreate('.tip-message-3', 'textarea-tip-3', { position: 'top', maxWidth: 330 });

  tippedCreate2(
    '.tip-to-not-entrepreneur',
    'Hangetel pakkumiste tegemiseks logige sisse ettevõtjana',
    {}
  );

  tippedCreate2(
    '.tip-to-change-bid',
    'Pakkumise muutmiseks kliki nupul "Muuda pakkumist".',
    {}
  );

  tippedCreate2(
    '.tip-not-offer-phase',
    'Pakkumiste faas on lõppenud. Pakkumist ei saa enam teha.',
    {}
  );

  tippedCreate2(
    '.tip-no-edits-left',
    'Olete oma pakkumist 3 korda muutnud. Pakkumise muutmine ei ole enam võimalik.',
    {}
  );

  tippedCreate2(
    '.tip-main-contractor',
    'Pakkumiste muutmine on võimalik ainult erahangetes. Alltöövõtu hangete pakkumised ei ole muudetavad.',
    {}
  );

  //Choose winner table modal
  $('.trigger-choosewinnertable-modal').click(function () {
    $('.choosewinnertable-modal').addClass('active');
    return false;
  });

  //End hange modal
  $('.trigger-endhange-modal').click(function () {
    $('.endhange-modal').addClass('active');
    return false;
  });
});

/**
 * For Choose winner from offers
 */
const triggerChooseWinnerModal = '.trigger-choosewinner-modal';
$(document).on('click', triggerChooseWinnerModal, function () {
  const chooseWinnerModal = $('.choosewinner-modal');
  const data = $(this).data();
  chooseWinnerModal.find('a.border-link').attr('href', data.company_url).html('ID' + data.company_id);
  if (data.rating > 0) {
    chooseWinnerModal.find('.callcompanies-rating-nr').html(data.rating).show();
  } else {
    chooseWinnerModal.find('.callcompanies-rating-nr').hide();
  }

  chooseWinnerModal.find('.amount-info').html(parseInt(data.amount));
  chooseWinnerModal.find('.prepay-info').html(data.prepay);
  chooseWinnerModal.find('.vat-info').html(data.vat);

  const winnerModalPrice = chooseWinnerModal.find('.offer-amount-override');
  if (winnerModalPrice.length > 0) {
    winnerModalPrice.val(parseInt(data.amount));
  }

  chooseWinnerModal.find('input[name=offerId]').val(data.offer_id);
  chooseWinnerModal.addClass('active');
  return false;
});

/**
 * Post Question to procurement
 * @param formId
 */
window.postQuestionForm = function (formId) {
  window.hanApp.loader.showLoading();
  const formElement = $('#' + formId);

  const data = formElement.serialize();
  const $url = formElement.attr('action');

  $.ajax({
    type: 'POST',
    url: $url,
    data: data,
    success: function (question) {

      let html = '<div class="hange-question">\n' +
        '<div class="hange-question-top">\n' +
        '<span class="bold">Küsimus:</span>\n' +
        '<img class="tip-message-rating" src="' + question.profileImgPath + '" alt="private">';

      html += '<a href="' + question.companyUrl + '" class="border-link text14">' +
        '<strong>ID' + question.askedById + '</strong></a>';

      html += '<span class="text-muted text14" style="margin-top: -4px;">' + question.askedAtFormat + '</span>';

      html += '</div>' +
        '<div class="hange-question-question">' + $.parseHTML(question.question)[0].nodeValue + '</div>' +
        '<p class="small light">' +
        '<a href="javascript:;" class="border-link trigger-modal" data-id="reason-modal" ' +
        'data-offending-customer="' + question.procurementOrganizerId + '" ' +
        'data-procurement="' + question.procurementId + '" ' +
        'data-question-answer="' + question.id + '" ' +
        '>Teavita reeglite rikkumisest</a>' +
        '</p>\n' +
        '<div class="hange-question-answer margintop20">\n' +
        '<p class="text14">' +
        'Korraldaja vastus:<br> ' +
        '<em class="text-muted">Hanke korraldaja ei ole küsimusele veel vastanud</em>\n' +
        '</p>\n' +
        '</div>\n' +
        '</div>';

      $('.hange-questions-list').append(html);
      formElement.find('textarea[name=question]').val('');
      window.hanApp.loader.hideLoading();
    },
    error: function (error) {
      if (error.status === 422) {
        fieldsAlertErrors(Object.values(error.responseJSON.errors));
      }
      window.hanApp.loader.hideLoading();
    }
  });
}

/**
 * Post answer to question procurement
 * @param formId
 */
window.postAnswerForm = function (formId) {
  window.hanApp.loader.showLoading();
  const formElement = $('#' + formId);

  const data = formElement.serialize();
  const $url = formElement.attr('action');

  $.ajax({
    type: 'POST',
    url: $url,
    data: data,
    success: function (question) {

      let html = '<div class="hange-question-answer margintop20">\n' +
        '<p class="text14">Korraldaja vastus:' +
        '<span class="text-muted">' + question.answeredAtFormat + '</span>' +
        '</p>\n' +
        '<div class="hange-question-answer-bubble">' + $.parseHTML(question.answer)[0].nodeValue + '</div>' +
        '</div>' +
        '<p class="small light">' +
        '<a href="javascript:;" class="border-link trigger-modal" data-id="reason-modal" ' +
        'data-offending-customer="' + question.procurementOrganizerId + '" ' +
        'data-procurement="' + question.procurementId + '" ' +
        'data-question-answer="' + question.id + '" ' +
        '>Teavita reeglite rikkumisest</a>' +
        '</p>';

      $(html).insertBefore(formElement);
      formElement.remove();
      window.hanApp.loader.hideLoading();
    },
    error: function (error) {
      if (error.status === 422) {
        fieldsAlertErrors(Object.values(error.responseJSON.errors));
      }
      window.hanApp.loader.hideLoading();
    }
  });
}

/**
 * For Question and Answer forms only
 */
jQuery(function () {
  const answerToQuestion = 'answerToQuestion';
  const answerDescription = 'textarea[name=answer]';
  const askQuestion = 'askQuestion';
  const questionDescription = 'textarea[name=question]';

  // Open model on question and answer has rule violation
  $('.' + answerToQuestion).on('submit', function (event) {
    event.preventDefault();
    const formId = $(this)[0].getAttribute('id');
    const text = $('#' + formId).find(answerDescription).val().trim();
    if (text === '') {
      return false;
    }
    validatedTextAgainstRuleViolations(text, formId, 'postAnswerForm', function (data) {
      if (data.matches.length === 0) {
        postAnswerForm(formId);
      }
      return false;
    });
    return false;
  });
  $('#' + askQuestion).on('submit', function (event) {
    event.preventDefault();
    const text = $(questionDescription).val().trim();
    if (text === '') {
      return false;
    }
    validatedTextAgainstRuleViolations(text, askQuestion, 'postQuestionForm', function (data) {
      if (data.matches.length === 0) {
        postQuestionForm(askQuestion)
      }
      return false;
    });
    return false;
  });

  const myTextEl = document.getElementById('description-content');
  if (myTextEl !== undefined && myTextEl !== null) {
    myTextEl.innerHTML = Autolinker.link(myTextEl.innerHTML);
  }
});

/**
 * Toggle Price in offer form
 * @param checkbox
 * @param input
 */
window.togglePriceInputFields = function (checkbox, input) {
  if ($(checkbox).is(':checked')) {
    $(input).slideDown();
  } else {
    $(input).slideUp();
  }
}

/**
 * For Offer form only
 */
jQuery(function () {
  var offerEditForm = 'offerFormEdit';
  var offerAddForm = 'offerFormAdd';
  const offerDescriptionPopup = 'textarea[name=offerDescriptionPopup]';
  const offerDescription = 'textarea[name=offerDescription]';
  const changeOfferModal = '.change-offer-modal-affirm';
  const descriptionModal = '.bid-description-modal';

  const togglePriceChange = '#toggle-pricechange';
  const togglePriceChangeMob = '#toggle-pricechangeMobile';
  const priceChangeInput = '.pricechange-input';
  const togglePrepayment = '#toggle-prepayment';
  const togglePrepaymentMob = '#toggle-prepaymentMobile';
  const prepaymentInput = '.prepayment-input';

  const offerSideBar = '.offerSideBar';

  $(document).on('click', '#submitOfferForm', function () {
    offerEditForm = "offerFormEdit";
    $('.change-offer-modal-affirm').addClass('active');
    return false;
  });

  $(document).on('click', '#submitOfferFormMobile', function () {
    offerEditForm = "offerFormEditMobile";
    $('.change-offer-modal-affirm').addClass('active');
    return false;
  });

  if (offerSideBar.length) {
    $(offerSideBar).on('click', function () {
      $('.loader').addClass('active');
      window.location.href = $(this).data('intended-login');
    });
  }

  $(".offer-edit-form").on('submit', function (event) {
    event.preventDefault();
    $(event.target).find('input[type=submit]:focus').prop('disabled', true);
    const text = $(this).find(offerDescription).val();
    validatedTextAgainstRuleViolations(text, offerEditForm, null, function (data) {
      if (data.matches.length === 0) {
        document.getElementById(offerEditForm).submit();
      } else {
        $("#" + offerEditForm).find('input[type=submit]').prop('disabled', false);
      }
      return false;
    });
    return false;
  });
  $(".offer-add-form").on('submit', function (event) {
    offerAddForm = $(this).attr('id');
    event.preventDefault();
    const text = $(this).find(offerDescription).val();
    validatedTextAgainstRuleViolations(text, offerAddForm, null, function (data) {
      if (data.matches.length === 0) {
        document.getElementById(offerAddForm).submit();
      }
      return false;
    });
    return false;
  });

  $('#offerFromConfirmSubmit').on('click', function () {
    $(changeOfferModal).removeClass('active');
    $("#" + offerEditForm).trigger('submit');
  });

  // Offer description
  $('#saveOfferDescription').on('click', function () {
    const description = $(offerDescriptionPopup).val();
    $(offerDescription).val(description);
    $(descriptionModal).removeClass('active');
  });
  $('.trigger-bid-description-modal').on('click', function () {
    const description = $(offerDescription).val();
    $(offerDescriptionPopup).val(description);
    $(descriptionModal).addClass('active');
    return false;
  });

  // Toggle price change
  togglePriceInputFields(togglePriceChange, priceChangeInput);
  $(togglePriceChange).on('click', function () {
    togglePriceInputFields(togglePriceChange, priceChangeInput);
  });

  // Toggle price change
  togglePriceInputFields(togglePriceChangeMob, priceChangeInput);
  $(togglePriceChangeMob).on('click', function () {
    togglePriceInputFields(togglePriceChangeMob, priceChangeInput);
  });

  // Toggle prepayment change
  togglePriceInputFields(togglePrepayment, prepaymentInput);
  $(togglePrepayment).on('click', function () {
    togglePriceInputFields(togglePrepayment, prepaymentInput);
  });

  // Toggle prepayment change
  togglePriceInputFields(togglePrepaymentMob, prepaymentInput);
  $(togglePrepaymentMob).on('click', function () {
    togglePriceInputFields(togglePrepaymentMob, prepaymentInput);
  });
});

/**
 * For advertiser banner only
 * @param swiperContainerClass
 * @param swiperPaginationClass
 */
function initSwiper(swiperContainerClass, swiperPaginationClass) {
  new Swiper(swiperContainerClass, {
    slidesPerView: 4,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    observer: true,
    observeParents: true,
    pagination: {
      el: swiperPaginationClass,
      clickable: true,
    },
    breakpoints: {
      240: {
        slidesPerView: 1,
        spaceBetween: 15
      },
      440: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      800: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4
      }
    }
  });
}
initSwiper('.partners-slider-1', '.partners-slider-pagination-1');

/**
 * For companies section
 */
new Swiper('.find-companies-slider', {
  slidesPerView: 4,
  spaceBetween: 15,
  slidesPerGroup: 4,
  pagination: {
    el: '.find-companies-slider-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 15,
      slidesPerGroup: 2
    },
    800: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    1100: {
      slidesPerView: 4,
      slidesPerGroup: 4
    }
  }
});
